import { GeoSuggest, IItemClickParams, IMultiSuggestResult } from '@cian/geosuggest-widget';
import { Button, FormField, MaskedInput } from '@cian/ui-kit';
import { EStatus } from 'shared/types/form';

interface IFirstStepFormProps {
  suggest: IMultiSuggestResult;
  addressErrorMessage: string | undefined;
  address: string;
  phoneErrorMessage: string;
  addressStatus: EStatus;
  onBtnNext: VoidFunction;
  onAddressValue: (value: string) => void;
  onItemGeoClick: (value: IItemClickParams) => void;
  onPhoneValue: (value: string) => void;
}

export const FirstStepForm: React.FC<IFirstStepFormProps> = ({
  suggest,
  addressErrorMessage,
  address,
  addressStatus,
  phoneErrorMessage,
  onAddressValue,
  onBtnNext,
  onItemGeoClick,
  onPhoneValue,
}) => {
  return (
    <div>
      <FormField label="Телефон" errorMessage={phoneErrorMessage}>
        <MaskedInput
          onChange={e => onPhoneValue(e)}
          mask="+7 000 000 00-00"
          size="M"
          placeholderChar="+"
          placeholder="+7"
          lazy
        />
      </FormField>
      <FormField label="Адрес квартиры" errorMessage={addressErrorMessage}>
        <GeoSuggest
          value={address}
          onValueChange={params => onAddressValue(params)}
          onItemClick={params => onItemGeoClick(params)}
          suggestData={suggest}
          inputStyle={{
            borderColor: 'var(--stroke-divider-default)',
            borderRadius: '8px',
            height: '44px',
            fontSize: '16px',
            padding: '7px 12px',
          }}
          placeholder="Город, улица, номер дома"
        />
      </FormField>
      <Button fullWidth size="M" loading={addressStatus === EStatus.Loading} onClick={onBtnNext}>
        Дальше
      </Button>
    </div>
  );
};
